import {Injectable} from '@angular/core';
import {Observable, Observer} from 'rxjs';
import {Router} from '@angular/router';

import * as SockJS from 'sockjs-client';
import * as Stomp from 'webstomp-client';


@Injectable()
export class BalanceService {
  private stompClient;
  private connection: Promise<any>;
  private connectedPromise: any;
  private listener: Observable<any>;
  private listenerObserver: Observer<any>;
  private requestHeader;
  private subscriber;

  constructor(public router: Router) {
    this.connection = this.createConnection();
    this.listener = this.createListener();
    this.stompClient = null;
    this.requestHeader = {};
    this.subscriber = null;
  }

  connect(searchString, startDate, endDate, language) {
    this.connection = this.createConnection();
    this.listener = this.createListener();
    this.stompClient = null;
    this.requestHeader = {};
    this.subscriber = null;

    /**
     * building absolute path so that websocket doesnt fail when deploying with a context path
     */
    const loc = window.location;
    let url = '//' + loc.host + loc.pathname + 'balance';
    const socket = new SockJS(url);
    this.stompClient = Stomp.over(socket);
    this.stompClient.connect(this.requestHeader, () => {
      this.connectedPromise('success');
      if (startDate != null && endDate != null && language != null) {
        this.sendRequest(searchString, startDate, endDate, language);
      }
    });
  }

  receive() {
    return this.listener;
  }

  sendRequest(searchString, startDdate, endDate, language) {
    if (this.stompClient !== null && this.stompClient.connected) {
      this.stompClient.send(
        '/topic/request/balance', // destination
        JSON.stringify({
          startDate: startDdate,
          endDate: endDate,
          language: language,
          searchString: searchString
        }), // body
        this.requestHeader // header
      );
    }
  }

  subscribe(onMessage) {
    this.connection.then(() => {
      this.subscriber = this.stompClient.subscribe('/user/queue/response/balance', data => {
        if (onMessage !== null) {
          onMessage(JSON.parse(data.body));
        }
        this.listenerObserver.next(JSON.parse(data.body));

        this.unsubscribe();
      });
    })
  }

  unsubscribe() {
    if (this.subscriber !== null) {
      this.subscriber.unsubscribe();
    }
    this.listener = this.createListener();

    this.disconnect();
  }

  disconnect () {
    if (this.stompClient !== null) {
      this.stompClient.disconnect();
      this.stompClient = null;
    }
    this.connection = this.createConnection();
  }

  private createConnection():Promise<any> {
    return new Promise((resolve, reject) => this.connectedPromise = resolve);
  }

  private createListener() {
    return new Observable(observer => this.listenerObserver = observer);
  }
}
